var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-3"},[_c('c-tabs',{attrs:{"variant":"pills","vertical":""}},[_c('c-tab',{attrs:{"active":"","title":"WP Engine"}},[_c('w-p-engine',{attrs:{"organisation":_vm.organisation}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }